import { gozokiApiWithAuth } from '../gozokiApi';
import type { AdminResponse, TokenResponse } from '../types/axios.types';

export const loginAdmin = async ({ email, password }: { email: string; password: string }) => {
    const response = await gozokiApiWithAuth.post<TokenResponse>('/auth/login-admin', {
        email,
        password,
    });
    return response.data;
};

export const meAdmin = async () => {
    const response = await gozokiApiWithAuth.get<AdminResponse>('/admin/me');
    return response.data;
};
